import informacoesIcon from "../assets/informacoes.png";
import dolarIcon from "../assets/dolar.png";
import calendarioIcon from "../assets/calendario.png";
import { useContext } from "react";
import { DollarContext } from "../contexts/DollarContext";

const CardNews = () => {
  const dollarPriceToday = useContext(DollarContext);
  return (
    <div className="bg-[#F9F9F9] rounded-md ml-4 lg:px-4 md:p-2  px-6 pt-6 xl:pt-6  text-boldGray opacity-100 text-xs relative md:col-span-3">
      <div className=" xl:max-w-[250px] relative h-full mx-auto">
        <div className="flex">
          <div className="flex items-center justify-center md:pr-2 pr-4 border-r border-gray-300 min-w-[20px] min-h-[20px] xl:min-h-[26px] xl:min-w-[26px]">
            <img
              className="w-[20px] h-[20px] xl:min-h-[26px] xl:min-w-[26px]"
              src={dolarIcon}
              alt=""
            />
          </div>

          <div className="md:ml-2 ml-4">
            <p className="xl:text-base">
              <span className="font-bold">Dólar hoje</span>
              <br />
              {dollarPriceToday}
            </p>
          </div>
        </div>
        <div className="flex md:mt-2 mt-6">
          <div className="flex items-center justify-center md:pr-2  pr-4 border-r border-gray-300 min-w-[20px] min-h-[20px] xl:min-h-[26px] xl:min-w-[26px] ">
            <img
              className="w-[20px] h-[20px] xl:w-[26px] xl:h-[26px]"
              src={calendarioIcon}
              alt=""
            />
          </div>

          <div className="md:ml-2 ml-4">
            <div className="xl:text-base">
              <p className="font-bold md:block">Próxima </p>
              <p className="font-bold md:block">carga em</p>
            </div>
          </div>
        </div>
        <div className="flex justify-end flex-col absolute md:bottom-0 right-0">
          <img
            src={informacoesIcon}
            alt=""
            className="lg:w-[90px] xl:w-full "
          />
        </div>
      </div>
    </div>
  );
};

export default CardNews;
